import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RplForm from '../../../components/forms/RplForm';
import { useRplApi } from '../../../hooks/useRplApi';
import { useNavigate, useParams } from 'react-router-dom';
import { RplDTO } from '../../../services/apiClient';
import { getRoles } from '../../../utils/tokenUtils';
import { RplStatusConstants } from '../../../constants/RplStatusConstants';

const RplEdit: React.FC = () => {
  const { getById, edit } = useRplApi();
  const [entityData, setEntityData] = useState<RplDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const roles = getRoles();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Rpls', href: '/admin/rpls' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Rpl data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: RplDTO) => {
    try {
      setIsSubmitting(true);

      if (roles?.includes('User') && data.rplStatusId === RplStatusConstants.REVIEWED_WITH_FEEDBACK) {
        data.rplStatusId = RplStatusConstants.PENDING_UPDATED;
      }
      await edit(id!, data);
      handleNavigate();
    } catch (error) {
      console.error('Error updating Rpl:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/dedicatedstatus"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission="Manage.Rpl.Edit"
    >
      {entityData ? (
        <RplForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={handleNavigate}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default RplEdit;
